import React from 'react'

type Props = {
  open: boolean
  onClose: () => void
  data: {
    id?: string
    date?: string
    document?: string
    tournament?: string
    level?: string
    type?: string
    amount?: number
    playerName?: string
  } | null
}

const fmt = (n: any) => {
  const v = Number(n)
  return isFinite(v) ? v.toFixed(2) : '0.00'
}

const PlayerSettlementViewModal: React.FC<Props> = ({ open, onClose, data }) => {
  if (!open || !data) return null
  const isAdjustment = data.type === 'ADJUSTMENT'
  const title = data.type === 'RECEIVABLE' ? 'Начисление взноса (RECEIVABLE)' : data.type === 'PAYMENT' ? 'Оплата игрока (PAYMENT)' : data.type === 'ADJUSTMENT' ? 'Корректировка долга (ADJUSTMENT)' : 'Документ'
  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded shadow p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-semibold text-gray-900">{title}</div>
          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded hover:bg-gray-50" onClick={onClose}>Закрыть</button>
          </div>
        </div>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <div className="text-xs text-gray-600">Дата</div>
              <div className="text-sm">{data.date?.slice(0,10) || '-'}</div>
            </div>
            <div>
              <div className="text-xs text-gray-600">Тип</div>
              <div className="text-sm">{data.type || '-'}</div>
            </div>
            <div>
              <div className="text-xs text-gray-600">Игрок</div>
              <div className="text-sm">{data.playerName || '-'}</div>
            </div>
            <div>
              <div className="text-xs text-gray-600">Уровень</div>
              <div className="text-sm">{data.level || '-'}</div>
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-600">Документ</div>
            <div className="text-sm break-words">{data.document || '-'}</div>
          </div>
          <div>
            <div className="text-xs text-gray-600">Сумма, MDL</div>
            <div className="text-lg font-semibold">{fmt(data.amount)}</div>
          </div>
        </div>
        {/* кнопка редактирования убрана по требованию: правим только из списка отмен */}
      </div>
    </div>
  )
}

export default PlayerSettlementViewModal


